import React from "react";
import { defineMessages, useIntl } from "react-intl";

import Combobox from "@/components/combobox/combobox";
import { Column, HStack, Layout, Text } from "@/components/ui";
import { PredictionsSearchProvider } from "@/contexts/predictions-search-context";
import { useRecentSearches } from "@/hooks";
import { predictionsSearchHistory } from "@/settings";

const messages = defineMessages({
  title: { id: "predictions.title", defaultMessage: "Predictions" },
  searchPlaceholder: {
    id: "predictions.search_placeholder",
    defaultMessage: "Search Predictions",
  },
});

interface PredictionsPageProps {
  children: React.ReactNode;
}

/** Page to display predictions. */
export default function PredictionsPage({ children }: PredictionsPageProps) {
  const intl = useIntl();
  const {
    value,
    setValue,
    debouncedValue,
    recentSearches,
    commitSearch,
    clearRecentSearch,
    clearRecentSearches,
  } = useRecentSearches(predictionsSearchHistory);

  return (
    <PredictionsSearchProvider value={debouncedValue}>
      <Layout.Main className="md:col-span-12! lg:col-span-9!">
        <Column
          labelElement={
            <HStack space={4} alignItems="center" className="relative w-full">
              <Text size="xl" weight="bold" tag="h1">
                {intl.formatMessage(messages.title)}
              </Text>

              <div className="absolute left-[50%] hidden w-72 flex-1 -translate-x-1/2 md:block">
                <Combobox
                  label={intl.formatMessage(messages.searchPlaceholder)}
                  placeholderText={intl.formatMessage(
                    messages.searchPlaceholder,
                  )}
                  value={value}
                  onValueChange={setValue}
                  recentSearches={{
                    items: recentSearches,
                    onRemove: clearRecentSearch,
                    onClearAll: clearRecentSearches,
                  }}
                  onEnterWithoutSelection={commitSearch}
                />
              </div>
            </HStack>
          }
          withBackButton={false}
          labelElementCentered
          content="list"
        >
          {children}
        </Column>
      </Layout.Main>
    </PredictionsSearchProvider>
  );
}
